import React, { useState, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { Switch, Text } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TrendTable from './Table';
import Visualis from './Visualis';
import { useIntl, useSelector, getLocale } from 'umi';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { getMetricTitle } from '@/pages/intelligence/utils/common';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import GuideCompetitor, {
  COMPETITOR_GUIDE_CLASSNAMES,
  PREDICTED_LINE_CHART_DEMO_WIDTH,
  PREDICTED_LINE_CHART_DEMO_HEIGHT,
} from '@intelligence/components/UserGuide/Competitor';
import { namespace as GUIDE_NAMESPACES, GUIDE_TYPE_INTELLIGENCE_COMPETITOR } from '@home/models/guide';


const TrendsCard = (props: any) => {
  const {
    loading,
    tableData = [],
    tableTotal = 0,
    lineData,
    pageId,
    isDropdown,
    showRankSwitch,
    entityType = '',
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    trendComputeType,
    trendCount,
    dataSource,
    isPullOffGame,
    pullOffTime,
    dateValue,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    metricKey,
    earliestLoading,
    cardStatus,
    trendLoading,
    trendRankSwitch,
    setTrendRankSwitch,
    firstWeekSinceReleaseDates,
    pageSortAttr,
    onTableSortChage,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  const { guideType } = useSelector((state: any) => state?.[GUIDE_NAMESPACES] || {});
  const isCompetitorUserGuide = guideType === GUIDE_TYPE_INTELLIGENCE_COMPETITOR;

  // console.log('TrendsCard',props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { isLoading, isError, isNoData } = cardStatus || {};
  const [trendSwitch, setTrendSwitch] = useState(trendRankSwitch);
  const [exceptRankLineList, setExceptRankLineList] = useState<any[]>([]);
  //用于识别折线图中是否存在补齐数据,当没有补齐数据时不显示图例，用于activeUser,revenue,download
  const [isPolishing, setIsPolishing] = useState(false);
  const [activeLineData, setActiveLineData] = useState<any>([]);

  //   trend折线图，是否存在补齐数据，涉及指标activeUser，revenue，download
  const getIsPolishing = () => {
    let metrics = JSON.parse(JSON.stringify(lineData))?.map(
      (item: any) => item?.metrics,
    );
    /**当b_predict为true时，即为存在补齐数据 */
    let isPolishing = metrics?.some((item: any) => {
      let pageMetric = item.filter((t: any) => {
        return t.metric === metricKey;
      })[0];
      return pageMetric?.b_predict == true;
    });
    setIsPolishing(isPolishing);
  };

  const handleLineList = (lineData: any[]) => {
    const exceptRankList: any[] = [];
    lineData.forEach((item: any) => {
      //过滤掉metrics里面的rank，将其赋值给新的数组
      const newMetrics = item.metrics?.filter((t: any) => {
        return t.metric !== 'rank';
      });
      let tmp = { time: item?.time, metrics: newMetrics };
      exceptRankList.push(tmp);
    });
    setExceptRankLineList(exceptRankList);
    if (!trendSwitch) {
      setActiveLineData(exceptRankList);
    }
  };

  useEffect(() => {
    /**获取是否有补齐数据 */
    getIsPolishing();
    /**如果有Rank开关，则处理数据过滤出Rank数据 */
    if (showRankSwitch) {
      handleLineList(lineData);
    } else {
      setActiveLineData(lineData);
    }
  }, [lineData]);

  const trendChange = (value: boolean) => {
    setTrendSwitch(value);
    setTrendRankSwitch?.(value);
    // console.log('lineData', lineData);
    // console.log('exceptRankLineList', exceptRankLineList);

    /**如果打开开关则过滤掉Rank数据 */
    if (value) {
      setActiveLineData(lineData);
      return;
    } else {
      setActiveLineData(exceptRankLineList);
    }
  };

  useEffect(() => {
    if (!isLoading && showRankSwitch) {
      trendChange(trendRankSwitch);
    }
  }, [isLoading, trendRankSwitch])

  const trendTitle = useMemo(() => {
    switch (pageId) {
      case 'activeusers':
        return 'dbi_active_users';
      case 'revenue':
        return 'dbi_revenue';
      case 'downloads':
        return 'dbi_downloads';
      default:
        return 'dbi_active_users'
    }
  }, [pageId, locale])

  return (
    <div className="dbi-trends-card">
      {isLoading || isNoData || isError || isDropdown ? (
        <CardSlotV2
          className="dbi-mobileGames-card-context"
          title={`${formatMessage({ id: trendTitle })}${locale === 'zh-CN' ? '' : ' '}${formatMessage({ id: `dbi_detail_trend` })}`}
          iconList={[]}
        >
          <CardStats cardStatus={cardStatus} isDropdown={isDropdown} />
        </CardSlotV2>
      ) : (
        <CardSlotV2
          className="dbi-mobileGames-card-context dbi-mobileGames-title-custom"
          title={`${formatMessage({ id: trendTitle })}${locale === 'zh-CN' ? '' : ' '}${formatMessage({ id: `dbi_detail_trend` })}`}
          subTitle={`${trendComputeType} ${getMetricTitle(
            pageId,
            dateType,
          )} : ${trendCount}`}
          rightText={`${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}`}
          rightTip={formatMessage({ id: `dbi_detail_earlistdate_info` })}
          rightDom={
            <div className='trends-card-title-flex'>
              {<>
                {
                  !earliestLoading && (
                    <div className='trends-card-title-flex'>
                      <span className="trends-card-title-subtext">
                        {`${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}`}
                      </span>

                      <TipContext
                        className="trends-card-title-ml"
                        Performance="left"
                        tipText={formatMessage({ id: `dbi_detail_earlistdate_info` })}
                      />
                    </div>)}
              </>}
              {showRankSwitch && (
                <div className='trends-card-title-flex'>
                  <Switch
                    className="trends-card-title-ml"
                    onClick={() => trendChange(!trendSwitch)}
                    value={trendSwitch}
                  ></Switch>
                  <Text className="trends-card-title-subtext trends-card-title-ml">
                    Rank
                  </Text>
                </div>
              )}
            </div>
          }
        >
          <div className="trends-card-line" style={{ position: 'relative' }}>
            <Visualis
              isPolishing={isPolishing} //是否有补齐数据
              // lineData={lineData} //折线数据，已经处理了交互，可直接展示
              islowerGame={isPullOffGame} //下架的时间
              lowerGameTime={pullOffTime} //是否有下架时间的游戏
              dateType={dateType}
              dataSource={dataSource} //旧情报的platform
              currentType={pageId}
              dateValue={dateValue}
              baseReleaseTime={baseReleaseTime}
              earliestPeriod={earliestPeriod}
              // chartDataList={chartDataList}
              getMetricTitle={getMetricTitle}
              // tableData={tableData}
              lineData={activeLineData}
              trendSwitch={trendSwitch}
              trendLoading={trendLoading}
              firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
              enableOpinionEventAnnotation={enableOpinionEventAnnotation}
              controlledEventAnnotation={controlledEventAnnotation}
            />
            {/* Competitor新手引导 需要的dom节点 */}
            <div
              style={{
                width: PREDICTED_LINE_CHART_DEMO_WIDTH,
                height: PREDICTED_LINE_CHART_DEMO_HEIGHT,
              }}
              className={classnames(COMPETITOR_GUIDE_CLASSNAMES.ELEMENT6, { show: isCompetitorUserGuide })}
            ></div>
            {/* Competitor新手引导 */}
            <GuideCompetitor />
          </div>
          <TrendTable
            tableData={tableData}
            pageId={pageId}
            dataSource={dataSource}
            entityType={entityType}
            gameName={gameName}
            gameCover={gameCover}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            showRankSwitch={showRankSwitch} //展示Rank列
            pageSortAttr={pageSortAttr}
            onTableSortChage={onTableSortChage}
          />
        </CardSlotV2 >
      )}
    </div >
  );
};
export default TrendsCard;
